import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Attach the signed-in user's token to backend API calls so per-user settings
// (ZIP, radius, My Stores) resolve server-side. Guests have no token.
const _nativeFetch = window.fetch.bind(window);
const _apiBase = `${process.env.REACT_APP_BACKEND_URL}/api/`;
window.fetch = (input, init = {}) => {
  const url = typeof input === "string" ? input : input?.url || "";
  const token = localStorage.getItem("auth_token");
  if (token && url.startsWith(_apiBase)) {
    const headers = new Headers(init.headers || (typeof input !== "string" ? input.headers : undefined));
    if (!headers.has("Authorization")) headers.set("Authorization", `Bearer ${token}`);
    return _nativeFetch(input, { ...init, headers });
  }
  return _nativeFetch(input, init);
};

// Register service worker for PWA + Share Target support
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/service-worker.js").catch(() => {});
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
